import { Link } from "react-router";

/**
 * SFWL-015 / PR #147 cross-review (jmusterman): Billing is not a top-level
 * nav link — it's an entry point here that hands off to the dedicated
 * `/billing` route (the invoice list, expand-line-items, PDF-download UI
 * lives there, not embedded in Settings). This tab is deliberately just a
 * card + link out, unlike the other tabs which are full inline panels.
 *
 * View-only gating happens one level up in `Settings.tsx` (the tab itself
 * is omitted from the tab bar for a view-only member, mirroring how
 * `NAV_LINKS` used to hide the entry) — this component only ever renders
 * for a member who can already reach it, so it does no `isViewOnly` check
 * of its own. The server's `WriteAccessGuard` on every `v1/billing` route
 * (including GETs) remains the real access-control gate either way; this
 * is UX only.
 */
export function BillingSettings() {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="text-lg font-semibold text-slate-900">Billing</h2>
          <p className="mt-1 text-sm text-slate-500">
            View monthly invoices, line items, and download PDFs.
          </p>
        </div>
        <Link
          to="/billing"
          className="shrink-0 rounded-xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-800"
        >
          View invoices
        </Link>
      </div>
    </div>
  );
}
